module.exports = __webpack_public_path__ + "static/media/legal.b98aae7e.svg";